import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { authInitializerProvider } from './initializers/auth.initializer';
import { configInitializerProvider } from './initializers/config.initializer';
import { themeInitializerProvider } from './initializers/theme.initializer';

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    configInitializerProvider,
    authInitializerProvider,
    themeInitializerProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in AppModule only.');
    }
  }
}
